import React from 'react';
import useStore from '../../../../store';
import './DebugInfo.css';
import { formatBytes, formatNum } from '../../../../utils/formatter';

function DebugInfo() {

    const pointerPosition = useStore(s => s.pointerPosition);

    const store = useStore.getState();
    const { puzzleRender, puzzleRedraw, debugCounter } = store;


    const { ref } = store;
    const { puzzle } = ref;
    const { boardTransform, boardCanvas } = puzzle;
    const boardCanvasRect = boardCanvas.element?.getBoundingClientRect?.();

    const { state: puzzleState, config } = useStore(s => s.ref.puzzle);
    const {
        draggingPiece,
        hoveredPieceId,
        placedPiecesCount,
        rows,
        cols,
        imageDimensions,
        boardDimensions,
        trayScrollTop,
        puzzleImageElement, // Достаем элемент картинки
    } = puzzleState;


    const totalPieces = rows * cols;
    const draggingPieceData = draggingPiece ? puzzleState.pieces[draggingPiece.pieceId] : null;

    // Примерная оценка размера изображения в памяти (очень грубо)
    // width * height * 4 байта (RGBA)
    const estimatedImageSize = puzzleImageElement
        ? formatBytes(puzzleImageElement.naturalWidth * puzzleImageElement.naturalHeight * 4)
        : 'N/A';



    return (
        <div className="debug-info-menu">
            <h4>Info Panel</h4>
            <div>Placed: {placedPiecesCount || 0} / {totalPieces || '?'}</div>
            {hoveredPieceId && (
                <div>Hovered ID: {hoveredPieceId}</div>
            )}
 
              {imageDimensions && boardDimensions && (
                <div className="info-section">
                  <span>Image: {imageDimensions.width}x{imageDimensions.height} (~{estimatedImageSize})</span>
                  <span>Board Dim: {formatNum(boardDimensions.width)}x{formatNum(boardDimensions.height)}</span>
                  <span>Tray Scale: {formatNum(config.trayPieceScale)}</span>
                </div>
              )}

              {puzzleState.rows && (
                <div>
                  <span>Grid: {puzzleState.rows} x {puzzleState.cols}</span>
                </div>
              )}
              {puzzleState.pieceBaseDimensions && (
                <div>
                  <span>Piece: {formatNum(puzzleState.pieceBaseDimensions.width)} x {formatNum(puzzleState.pieceBaseDimensions.height)}</span>
                </div>
              )}
        

              <div>
                <span>Puzzle Render: {puzzleRender}</span>
                <br />
                <span>Puzzle Redraw: {puzzleRedraw}</span>
                <br />
                <span>Debug Counter: {debugCounter}</span>
              </div>

              <div>
                <span>Pointer: {formatNum(pointerPosition.x)}, {formatNum(pointerPosition.y)}</span>
              </div>

              <div>
                <span>Canvas Position: {formatNum(puzzle.temp.canvasPosition.x)}, {formatNum(puzzle.temp.canvasPosition.y)}</span>
              </div>

              <div>
                <span>Canvas Size: w: {formatNum(boardCanvas.element?.width)}, h: {formatNum(boardCanvas.element?.height)}</span>
              </div>

              <div>
                <span>boardTransform: </span>
                <br />
                <span>{formatNum(boardTransform.x)}, {formatNum(boardTransform.y)} </span>
                <br />
                <span>Scale: {formatNum(boardTransform.scale)} </span>
              </div>

              <div>
                <span>boardCanvasRect: </span>
                <br />
                <span>x: {formatNum(boardCanvasRect?.x)}, y: {formatNum(boardCanvasRect?.y)} </span>
                <br />
                <span>width: {formatNum(boardCanvasRect?.width)}, height: {formatNum(boardCanvasRect?.height)} </span>
              </div>

              {puzzle.zoom.isZooming && (
                <div>
                  <span>distanceDeltaRatio: {puzzle.zoom.debug.distanceDeltaRatio}</span>
                  <br />
                  <span>centerDelta: {puzzle.zoom.debug.centerDelta}</span>
                  <br />
                  <span>zoomActivated: {puzzle.zoom.zoomActivated ? 'true' : 'false'}</span>
                  <br />
                  <span>panActivated: {puzzle.zoom.panActivated ? 'true' : 'false'}</span>
                  <br />
                  <span>Zoom touches: {puzzle.zoom.debug.touches.map(t => `${formatNum(t.clientX)}, ${formatNum(t.clientY)}`).join(', ')}</span>
                </div>
              )}

              {draggingPiece && draggingPieceData && (
                <div className="info-section">
                    <span>Dragging: ID {draggingPiece.pieceId} ({draggingPiece.pointerType})</span>
                    <span>Base Dim: {formatNum(draggingPieceData.baseDimensions.width)}x{formatNum(draggingPieceData.baseDimensions.height)}</span>
                    <span>Offset: {formatNum(draggingPiece.offset.x)}x{formatNum(draggingPiece.offset.y)}</span>
                    <span>Rotation: {formatNum(draggingPiece.piece.rotation)}</span>
                    {/* Можно добавить текущую позицию, если она легко доступна */}
                </div>
            )}
            {/* Добавь сюда любую другую полезную информацию из стора */}
        </div>
    );
} 

export default DebugInfo;